const numberFormatter = (number) => {
  try {
    return number.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(/,/g, ' ').replace('.', ',')
  } catch (e) {
  }
}
const numberFormatterThousand = (number) => {
  try {
    return number.toLocaleString().replace(/,/g, ' ')
  } catch (e) {
  }
}

const GlobalMixins = {
  methods: {
    numberFormatter (number) {
      return numberFormatter(number)
    },
    numberFormatterThousand (number) {
      return numberFormatterThousand(number)
    },
    getPermission (perm) {
      if (JSON.parse(localStorage.getItem('userDataOptions')) !== null && typeof JSON.parse(localStorage.getItem('userDataOptions')).options[perm] !== 'undefined') {
        return JSON.parse(localStorage.getItem('userDataOptions')).options[perm]
      }
      return false
    }
  },
  filters: {
    filter (number) {
      return numberFormatter(number)
    },
    thousandSep (number) {
      return numberFormatterThousand(number)
    }
  }
}

export default GlobalMixins



// WEBPACK FOOTER //
// ./src/helpers/GlobalMixins.js